import React from 'react';

import PhotoOfAlan from 'core/images/AlanHoney.jpg';
import GetInTouch from 'core/components/GetInTouch';

class About extends React.Component {
    render() {
        return (
            <div>
                <div className="md-flex pt-2">
                    <div className="md-col-4 lg-col-3 pb2">
                        <div className="center">
                            <img
                                src={PhotoOfAlan.src}
                                css={{ maxWidth: 300, width: '100%' }}
                                className="pr2 pb2"
                                alt="Alan Honey"
                            />
                        </div>

                        <GetInTouch />
                    </div>

                    <div className="md-col-8 lg-col-9">
                        <p css={{ marginTop: 0 }}>
                            Alan opened <em>Alan Honey Photography</em> for business in Manhattan,
                            Kansas, in August of 2003, after a successful run as manager of one of
                            the most respected studios in the West. In Salt Lake City, his clients
                            included Utah Jazz players, Olympic athletes, and even Sheryl Crow. He
                            specialized in portraits and weddings but was also the principal
                            photographer for a regional life-style magazine. He has photographed
                            weddings throughout the U.S. in places like Boston, Washington D.C., San
                            Diego, Las Vegas, and Dallas.
                        </p>

                        <p>
                            Here in Manhattan, he continues to concentrate on portraits and
                            weddings, and in only a few short years, he has become one of the most
                            sought after photographers in the area. As a member of the Kansas
                            Professional Photographers’ Association, he has won various awards for
                            his sensitive and artistic portraiture.
                        </p>

                        <p>
                            One of the reasons Alan’s family chose to move to Manhattan was because
                            of the great family values and solid work ethic found here. His kids
                            attend the local schools and he volunteers at his church. He is
                            establishing roots and will be in Manhattan for many years to come.
                        </p>

                        <p>
                            Whether you need a one-year portrait of your child or your
                            once-in-a-lifetime wedding photographed, you can be sure Alan will work
                            his hardest so that you end up with portraits that are unique and will
                            be treasures for years to come.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/About/index.js